/**
 * This has to be listed here:
 *   app/public/wp-content/mu-plugins/wp-common-plugin/src/Gutenberg/Blocks/webpack.config.js
 */
if ( document.readyState !== 'loading' ) {
	initTabsBlock();
} else {
	document.addEventListener( 'DOMContentLoaded', () => {
		initTabsBlock();
	});
}

function initTabsBlock() {
	// Validate if the block exists.
	const tabsBlocks = document.querySelectorAll( '.wp-block-colibri-tabs' );
	if ( ! tabsBlocks.length ) {
		return;
	}

	const debounce = require( 'lodash/debounce' );

	tabsBlocks.forEach( ( tabsBlock ) => {

		const tabs = tabsBlock.querySelectorAll( '[role="tab"]' );
		const tabList = tabsBlock.querySelector( '[role="tablist"]' );

		let maxTabsHeight = 0;

		tabs.forEach( ( tab ) => {
			// Get the highest tab
			maxTabsHeight = Math.max(maxTabsHeight, tab.offsetHeight );

			// Add a click event handler to each tab
			tab.addEventListener( 'click', changeTabs );
		} );

		// Enable arrow navigation between tabs in the tab list
		let tabFocus = 0;

		const initialActiveTab = tabsBlock.querySelector( '[aria-selected="true"]' );
		initialActiveTab.click();

		tabList.addEventListener( 'keydown', ( e ) => {
			// Move right
			if ( e.key === 'ArrowRight' || e.key === 'ArrowLeft' ) {
				tabs[tabFocus].setAttribute( 'aria-selected', false );
				if ( e.key === 'ArrowRight' ) {
					tabFocus++;
					// If we're at the end, go to the start
					if ( tabFocus >= tabs.length ) {
						tabFocus = 0;
					}
					// Move left
				} else if ( e.key === 'ArrowLeft' ) {
					tabFocus--;
					// If we're at the start, move to the end
					if ( tabFocus < 0 ) {
						tabFocus = tabs.length - 1;
					}
				}

				tabs[tabFocus].setAttribute( 'aria-selected', true );
				tabs[tabFocus].focus();
				tabs[tabFocus].click();

				setIndicator();
			}
		});

		window.addEventListener('resize', debounce(resizeFunction, 100), false);

		function resizeFunction() {
			setIndicator();
		}

		function changeTabs( e ) {
			const target = e.currentTarget;
			const parent = target.parentNode;
			const blockWrapper = parent.parentNode.parentNode;

			// Remove all current selected tabs
			parent
				.querySelectorAll( '[aria-selected="true"]' )
				.forEach( ( t ) => {
					t.setAttribute( 'aria-selected', false );
				});

			// Set this tab as selected
			target.setAttribute( 'aria-selected', true );

			setIndicator();

			// Hide all tab panels
			blockWrapper
				.querySelectorAll( '[role="tabpanel"]' )
				.forEach((p) => p.setAttribute( 'hidden', true ) );

			// Show the selected panel
			blockWrapper
				.querySelectorAll( `#${target.getAttribute( 'aria-controls' )}` )
				.forEach((p) => p.removeAttribute( 'hidden' ) );

			document.body.dispatchEvent(
				new CustomEvent('COLIBRI:Tabs:tabChanged', {
					detail: { tab: blockWrapper }
				})
			);
		}

		function setIndicator() {
			const indicator = tabsBlock.querySelector( '.wp-block-colibri-tabs__indicator' );
			const activeTab = tabsBlock.querySelector( '[aria-selected="true"]' );

			indicator.style.width = activeTab.offsetWidth + 'px';
			indicator.style.left = activeTab.offsetLeft + 'px';

			if ( window.innerWidth < 1024 ) {
				indicator.style.bottom = 'auto';
				indicator.style.top = ( activeTab.offsetTop + activeTab.offsetHeight - indicator.offsetHeight + 1 ) + 'px';
			} else {
				indicator.style.bottom = 0;
				indicator.style.top = 'auto';
			}
		}
	});

	// Open Address Bar Anchor Tag Tab Directly.

	openTabWithHash();

	window.addEventListener('hashchange', openTabWithHash);

	function openTabWithHash() {
		let hash = window.location.hash;

		if ( hash ) {
			hash = hash.replace( '#', '' );
			const tabPanel = document.querySelector( `[data-anchor="${hash}"]` );

			if ( tabPanel !== null ) {
				const tabButton = document.getElementById( tabPanel.getAttribute('aria-labelledby') );

				if ( tabButton !== null ) {
					tabButton.click();

					if ( 'scrollToAnchor' in tabPanel.dataset && tabPanel.dataset.scrollToAnchor.toString() === 'true' ) {
						const offset = document.querySelector('.site-header').offsetHeight + 40;
						scrollToTarget( tabButton, offset );
					}
				}
			}
		}
	}
}

function scrollToTarget( targetEl, offset = 0 ) {
	var elementPosition = targetEl.getBoundingClientRect().top;
	var offsetPosition = elementPosition + window.pageYOffset - offset;

	window.scrollTo({
		top: offsetPosition,
		behavior: 'smooth'
	});
}
